// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { FORGOT_PASSWORD } from "lib/constants";
import { putAPICall } from "lib/callApi";
import { CircularProgress, Stack } from "@mui/material";
import CoverLayout from "../components/CoverLayout";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const emailHandler = async (e) => {
    const { value } = e.target;
    if (value !== "") {
      if (
        value
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          )
      ) {
        setEmail(value);
        setEmailError(false);
      } else {
        setEmailError(true);
        setEmailErrorMessage("Email format is not proper!");
      }
    } else {
      setEmailError(true);
      setEmailErrorMessage("Email field is required!");
    }
  };

  const onSubmit = async (e) => {
    try {
      e.preventDefault();
      if (email && email !== "") {
        setIsLoading(true);
        const dataToPass = {
          email,
        };

        const result = await putAPICall(FORGOT_PASSWORD, null, dataToPass);

        if (result.data.success) {
          setIsLoading(false);
          enqueueSnackbar(
            JSON.stringify({
              icon: "info",
              title: "Information",
              text: result.data.message,
            }),
            {
              variant: "custom",
            }
          );
          navigate("/sign-in");
        } else {
          setIsLoading(false);
          setEmailError(true);
          setEmailErrorMessage(result.data.message);
        }
      } else {
        setEmailError(true);
        setEmailErrorMessage("Email field is required");
      }
    } catch (error) {
      setIsLoading(false);
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: "Something went wrong!",
        }),
        {
          variant: "custom",
        }
      );
    }
  };
  const handleKeyPress = async (event) => {
    if (event.key === "Enter") {
      onSubmit(event);
    }
  };

  return (
    <CoverLayout coverHeight="50vh">
      {isLoading ? (
        <Stack alignItems="center">
          <CircularProgress
            sx={{
              position: "fixed",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 9,
            }}
            color="info"
            size="10vh"
          />
        </Stack>
      ) : (
        ""
      )}
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="secondary"
          mx={2}
          mt={-3}
          py={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
            Forgot Password
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            You will receive an e-mail in your registered email
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox
            component="form"
            role="form"
            sx={{
              "& .MuiFormHelperText-root": { color: "#d32f2f" },
            }}
          >
            <MDBox mb={4}>
              <MDInput
                type="email"
                label="Email*"
                variant="standard"
                fullWidth
                onChange={(e) => emailHandler(e)}
                error={emailError}
                helperText={emailError ? emailErrorMessage : ""}
                onKeyPress={handleKeyPress}
              />
            </MDBox>
            <MDBox mt={6} mb={1}>
              <MDButton color="primaryRed" fullWidth onClick={onSubmit} disabled={emailError}>
                submit
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default ForgotPassword;
